import React from "react";
import { Facebook, Linkedin, Youtube, Twitter } from "react-bootstrap-icons";

const Footer = () => {
  return (
    <footer className="container my-5">
      <div
        className="border border-2 border-secondary rounded-4 p-4 bg-white"
        style={{ fontSize: "14px" }}
      >
        <div className="row row-cols-1 row-cols-md-4 g-4 text-start">
          {/* ===== Column 1 - Social Icons ===== */}
          <div className="d-flex flex-column align-items-start gap-3">
            <div className="fw-bold small">Follow Us</div>
            <div className="d-flex flex-column gap-2">
             <a
              href="https://web.facebook.com/profile.php?id=61567195719844"
  target="_blank"
  rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
             >
  <div
    className="border border-dark rounded-circle d-flex align-items-center justify-content-center"
    style={{ width: "35px", height: "35px", fontSize: "14px" }}
  >
    <Facebook />
  </div>
</a>

              
              <a
  href="https://www.linkedin.com/in/jad-technologies-156529395"
  target="_blank"
  rel="noopener noreferrer"
  style={{ textDecoration: "none" }}
>
  <div
    className="border border-dark rounded-circle d-flex align-items-center justify-content-center"
    style={{ width: "35px", height: "35px", fontSize: "14px" }}
  >
    <Linkedin />
  </div>
</a>

              
<a
  href="https://x.com/TechnologiesJad"
  target="_blank"
  rel="noopener noreferrer"
  style={{ textDecoration: "none" }}
>
  <div
    className="border border-dark rounded-circle d-flex align-items-center justify-content-center"
    style={{ width: "35px", height: "35px", fontSize: "14px", color: "#000" }}
  >
    <i className="fa-brands fa-x-twitter"></i>
  </div>
</a>


            </div>
          </div>

          {/* ===== Column 2 - Use Cases ===== */}
          <div className="ps-md-4">
            <div className="fw-bold small mb-2">Use Cases</div>
            <ul className="list-unstyled small text-secondary mb-0">
              <li>UI Design</li>
              <li>UX Design</li>
              <li>Wireframing</li>
              <li>Brainstorming</li>
              <li>Online Whiteboard</li>
              <li>Team Collaboration</li>
            </ul>
          </div>

          {/* ===== Column 3 - Explore ===== */}
          <div className="ps-md-4">
            <div className="fw-bold small mb-2">Explore</div>
            <ul className="list-unstyled small text-secondary mb-0">
              <li>Design</li>
              <li>Prototyping</li>
              <li>Development Features</li>
              <li>Design Systems</li>
              <li>Collaboration Features</li>
              <li>Design Process</li>
              <li>FigJam</li>
            </ul>
          </div>

          {/* ===== Column 4 - Resources ===== */}
          <div className="ps-md-4">
            <div className="fw-bold small mb-2">Resources</div>
            <ul className="list-unstyled small text-secondary mb-0">
              <li>Blog</li>
              <li>Best Practices</li>
              <li>Colors</li>
              <li>Color Wheel</li>
              <li>Support</li>
              <li>Developers</li>
              <li>Resource Library</li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
